import * as React from "react"
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area"

import { cn } from "@/lib/utils"

const ScrollArea = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root>
>(({ className, children, ...props }, ref) => {
  // Radix ScrollArea não funciona com max-height no Root - precisa estar no Viewport.
  // Ref: https://github.com/radix-ui/primitives/issues/2307
  const rootClasses: string[] = [];
  const viewportClasses: string[] = ["h-full", "w-full", "rounded-[inherit]"];
  const classList = (className || "").split(/\s+/);
  for (const c of classList) {
    if (c && (c.startsWith("max-h-") || (c.startsWith("h-") && !c.startsWith("hover:")))) {
      viewportClasses.push(c);
    } else if (c) {
      rootClasses.push(c);
    }
  }
  return (
  <ScrollAreaPrimitive.Root
    ref={ref}
    className={cn("relative overflow-hidden", rootClasses.join(" "))}
    {...props}
  >
    <ScrollAreaPrimitive.Viewport className={cn(...viewportClasses)}>
      {children}
    </ScrollAreaPrimitive.Viewport>
    <ScrollBar />
    <ScrollAreaPrimitive.Corner />
  </ScrollAreaPrimitive.Root>
  );
})
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName

const ScrollBar = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>
>(({ className, orientation = "vertical", ...props }, ref) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={cn(
      "flex touch-none select-none transition-colors",
      orientation === "vertical" &&
        "h-full w-2.5 border-l border-l-transparent p-[1px]",
      orientation === "horizontal" &&
        "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      className
    )}
    {...props}
  >
    <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 rounded-full bg-border" />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
))
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName

export { ScrollArea, ScrollBar }
